import React, { Fragment } from 'react';
import {
  TermsList,
  TermsRow,
  TermsSubRow,
  TermsSubLabel,
  TermsSubText,
  TermsListLabel,
  TermsListText,
} from './TermsAndConditions.styles';
import { DataInfo } from './constants/data';

interface TermsListProps {
  items: DataInfo[];
}

const parseBoldText = (text: string) => {
  return text.split(/(<strong>.*?<\/strong>)/g).map((part, index) => {
    if (part.startsWith('<strong>') && part.endsWith('</strong>')) {
      return <strong key={index}>{part.replace(/<\/?strong>/g, '')}</strong>;
    }
    return part;
  });
};

const TermsListComponent: React.FC<TermsListProps> = ({ items }) => {
  return (
    <TermsList>
      {items.map(({ label, text, subInfo }, index) => (
        <React.Fragment key={index}>
          <TermsRow bottomMargin={index === items.length - 1 && !subInfo ? '26px' : '8px'}>
            <TermsListLabel>{label}</TermsListLabel>
            <TermsListText>{parseBoldText(text)}</TermsListText>
          </TermsRow>

          {subInfo &&
            subInfo.map(({ label, text, nestedSubInfo }, subIndex) => (
              <Fragment key={subIndex}>
                <TermsSubRow
                  key={`${index}-${subIndex}`}
                  bottomMargin={
                    subIndex === subInfo.length - 1
                      ? index === items.length - 1
                        ? '26px'
                        : '18px'
                      : '8px'
                  }
                >
                  <TermsSubLabel>{label}</TermsSubLabel>
                  <TermsSubText>{parseBoldText(text)}</TermsSubText>
                </TermsSubRow>

                {nestedSubInfo &&
                  nestedSubInfo.map(({ label, text }, nestedIndex) => (
                    <TermsSubRow
                      style={{ marginLeft: '60px' }}
                      key={`${subIndex}-${nestedIndex}`}
                      bottomMargin={
                        subIndex === subInfo.length - 1
                          ? index === items.length - 1
                            ? '26px'
                            : '18px'
                          : '8px'
                      }
                    >
                      <TermsSubLabel>{label}</TermsSubLabel>
                      <TermsSubText>{parseBoldText(text)}</TermsSubText>
                    </TermsSubRow>
                  ))}
              </Fragment>
            ))}
        </React.Fragment>
      ))}
    </TermsList>
  );
};

export default TermsListComponent;
